module.exports = __webpack_public_path__ + "static/img/zzrz06.ab7e0be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzrz06.jpg
// module id = Y3+S
// module chunks = 1